import { useQuery } from '@tanstack/react-query';

import { getServiceFilterOptions } from '../../riders/api/services/RiderServices';

export const RIDES_SERVICES_QUERY_KEY = 'rides-services';

export const useRidesServices = ({ enabled }: { enabled: boolean }) => {
  const { data, isFetching } = useQuery({
    queryKey: [RIDES_SERVICES_QUERY_KEY],
    queryFn: async ({ signal }) => {
      const response = await getServiceFilterOptions(signal);

      if (response.type === 'error') {
        throw new Error(response.error.errors[0] ?? 'Failed to load services');
      }

      return response.data;
    },
    enabled,
  });

  return {
    services: data?.services ?? [],
    isFetching,
  };
};
